export class Schedule {
  public id: string;
  public type?: any;
  public workStart: any;
  public lunchStart: any;
  public lunchEnd: any;
  public workEnd: any;

  constructor(workStart: any,
              lunchStart: any,
              lunchEnd: any,
              workEnd: any) {
    this.workStart = workStart;
    this.lunchStart = lunchStart;
    this.lunchEnd = lunchEnd;
    this.workEnd = workEnd;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/schedule.model.ts